import { useAccountTierFieldsFragment } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '../../contexts';

export const useIsEnterpriseAccount = () => {
  const accountId = useActiveAccountId();

  const { complete, data: account } = useAccountTierFieldsFragment({
    from: { __typename: 'Account', id: accountId },
  });

  return complete ? account?.tier === 'ENTERPRISE' : undefined;
};
